/**
 * Eleição de aba líder para o agendador.
 *
 * Em multi-tab, apenas a aba que segura o lock exclusivo
 * `pharuerp:scheduler-leader` executa os agendamentos. As outras abas ficam
 * "passivas" (mostram histórico e configuração, mas não disparam).
 *
 * `navigator.locks` é suportado em Chrome/Edge/Firefox modernos. Como a
 * feature toda requer File System Access (Chrome/Edge), está garantido.
 */

const LOCK_NAME = "pharuerp:scheduler-leader";

/**
 * Tenta adquirir liderança. A função `onLider` é chamada quando esta aba
 * vira líder; o lock é mantido enquanto a Promise interna não resolve.
 *
 * Retorna uma função `liberar()` para abdicar manualmente (raramente útil).
 *
 * @param {(setNaoLider: () => void) => void} onLider
 * @param {() => void} [onPerdeu]
 */
export function adquirirLideranca(onLider, onPerdeu) {
  if (typeof navigator === "undefined" || !navigator.locks) {
    // Fallback: assume líder. Sem locks, multi-tab pode disparar duplicado;
    // aceitável em browsers que não suportam (a feature inteira nem
    // funciona neles porque dependem de File System Access).
    onLider(() => {});
    return () => {};
  }

  let resolveLock;
  let liberou = false;
  const promiseLock = new Promise((resolve) => {
    resolveLock = resolve;
  });

  const liberar = () => {
    if (liberou) return;
    liberou = true;
    if (resolveLock) resolveLock();
  };

  navigator.locks
    .request(LOCK_NAME, { mode: "exclusive" }, async () => {
      onLider(liberar);
      await promiseLock;
      if (onPerdeu) onPerdeu();
    })
    .catch(() => {
      // Se o lock for negado/abortado, não há liderança.
      if (onPerdeu) onPerdeu();
    });

  return liberar;
}
